(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gl_section_product_carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const carousels = new Map();

  function initialize(root) {
    root.querySelectorAll('.carousel-collection-section .gl_carousel_data').forEach(carousel => {
      if (carousels.has(carousel)) return;
      let frame = 0;
      let observedPhoto;
      const resizeObserver = new ResizeObserver(schedule);
      const mutationObserver = new MutationObserver(schedule);

      function update() {
        frame = 0;
        const photo = carousel.querySelector('.owl-item.active .product-element-top') || carousel.querySelector('.product-element-top');
        if (!photo || !carousel.isConnected) return;
        if (photo !== observedPhoto) {
          if (observedPhoto) resizeObserver.unobserve(observedPhoto);
          observedPhoto = photo;
          resizeObserver.observe(photo);
        }
        const photoBounds = photo.getBoundingClientRect();
        if (photoBounds.height > 0) {
          const center = photoBounds.top - carousel.getBoundingClientRect().top + photoBounds.height / 2;
          carousel.style.setProperty('--fsb-carousel-photo-center', `${center}px`);
        }
      }

      function schedule() {
        if (!frame) frame = requestAnimationFrame(update);
      }

      resizeObserver.observe(carousel);
      mutationObserver.observe(carousel, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      carousels.set(carousel, () => {
        cancelAnimationFrame(frame);
        resizeObserver.disconnect();
        mutationObserver.disconnect();
      });
      schedule();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', () => initialize(document));
  document.addEventListener('shopify:section:unload', event => {
    carousels.forEach((cleanup, carousel) => {
      if (event.target.contains(carousel)) {
        cleanup();
        carousels.delete(carousel);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
